import { createFileRoute } from '@tanstack/react-router';

import { DiagramGalleryPage } from '@/pages/diagram-gallery/diagram-gallery-page';

export const Route = createFileRoute('/crochet/')({
    component: CrochetGalleryRoute,
});

function CrochetGalleryRoute() {
    return <DiagramGalleryPage kind="crochet" />;
}
